/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * weather
 */

import $ from 'jquery';
import Flickity from 'flickity';


const weather = {
    cfg: {
        wrapper: document.querySelector('.js-weather'),
        language: 'de',
        slider: '.js-forecast',
        sliderOptions: {
            cellAlign: 'left',
            contain: true,
            draggable: true,
            friction: 1,
            lazyLoad: 2,
            selectedAttraction: 0.1,
            groupCells: true,
            setGallerySize: true,
            imagesLoaded: true,
            prevNextButtons: false,
            pageDots: false,
            wrapAround: false,
            // watchCSS: true

        }
    },

    init() {
        window.addEventListener('load', () => {
            if (this.cfg.wrapper) {
                this.cfg.language = this.cfg.wrapper.dataset.lang;
                /* eslint-disable */
                $.getJSON('https://api.openweathermap.org/data/2.5/weather?q=Plainfeld&units=metric&APPID=1e05badb113e8188d298e1f024d9119d&lang=' + this.cfg.language, (data) => {
                    // this.cfg.wrapper.innerHTML += JSON.stringify(data);

                    // Manipulate Current Temperature
                    this.cfg.wrapper.querySelector('.js-currentTemp').innerHTML = `${Math.round(data.main.temp*2)/2}&deg;`.replace('.', ',');
                    // Manipulate Current Description
                    this.cfg.wrapper.querySelector('.js-currentDescription').innerHTML = `${data.weather[0].description}`;
                    // Manipulate Current Location
                    this.cfg.wrapper.querySelector('.js-currentLocation').innerHTML = `${data.name}`;

                    // Manipulate Icon
                    this.cfg.wrapper.querySelector('.js-currentIcon').innerHTML = `
                      <svg class="a-svgSprite" viewbox="0 0 48 48">
                        <use xlink:href="/assets/images/svg/sprite/sprite.svg#${data.weather[0].id}"></use>
                      </svg>`;


                });

                // Get Forecast
                $.getJSON('https://api.openweathermap.org/data/2.5/forecast?q=Plainfeld&units=metric&APPID=1e05badb113e8188d298e1f024d9119d&lang=' + this.cfg.language, (forecast) => {
                    // this.cfg.wrapper.innerHTML += JSON.stringify(forecast);
                    let td = new Date();
                    let one_day = 1000*60*60*24;
                    let days = {'de':['Heute', 'Morgen'], 'en':['Today', 'Tomorrow']};
                    let weekdays = {'de':['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'], 'en':['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']};

                    forecast.list.forEach((item) => {
                        let dt = new Date(item.dt*1000);

                        // Convert both dates to milliseconds
                        let date1_ms = new Date(td.getFullYear(),td.getMonth(),td.getDate()).getTime();
                        let date2_ms = new Date(dt.getFullYear(),dt.getMonth(),dt.getDate()).getTime();

                        // Calculate the difference in milliseconds
                        let difference_ms = date2_ms - date1_ms;

                        // Convert back to days and return
                        let diff = Math.round(difference_ms/one_day);

                        let output = (diff <= 1) ? days[this.cfg.language][diff] : weekdays[this.cfg.language][dt.getDay()];

                        if (dt.getHours() == '10' || dt.getHours() == '16') {
                            this.cfg.wrapper.querySelector('.js-forecast').innerHTML += `
                                <div class="o-weather__slide" itemscope itemtype="http://schema.org/ImageObject">
                                    <div class="o-weather__slideInner">
                                        <div class="o-weather__forecastItem">
                                            <div class="o-weather__forecastDay">
                                                <span>${output}</span>
                                                <span>${dt.getHours() < 9 ? '0' + dt.getHours() : dt.getHours()}:${dt.getMinutes() < 9 ? '0' + dt.getMinutes() : dt.getMinutes()}</span>
                                            </div>
                                            <div class="o-weather__forecastIcon">
                                              <svg class="a-svgSprite" viewbox="0 0 48 48">
                                                <use xlink:href="/assets/images/svg/sprite/sprite.svg#${item.weather[0].id}"></use>
                                              </svg>
                                            </div>
                                            <div class="o-weather__forecastTemp">${Math.round(item.main.temp*2)/2}&deg;C</div>
                                        </div>
                                    </div>
                                </div>
                            `;
                        }
                    });

                    const sliders = [...document.querySelectorAll(this.cfg.slider)];
                    if (sliders) {
                        sliders.forEach((slider) => {
                            const flkty = new Flickity(slider, this.cfg.sliderOptions);
                            flkty.resize();

                            setTimeout(() => {
                                flkty.resize();
                                slider.classList.add('is-ready');
                            }, 1000);
                        });
                    }
                });
                /* eslint-enable */
            }
        });
    }
};

export default weather;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/weather/_script.js